<div id="content">
  <app-company-product-page-identity title="Comunicación"></app-company-product-page-identity>

  <section class="communication-section" [class.communication-section--pending]="!has_configured_channel() || has_bot_not_member()">
    <header class="communication-header">
      <div class="communication-header-icon" aria-hidden="true">
        <mat-icon>tag</mat-icon>
      </div>
      <div class="communication-header-text">
        <div class="communication-header-title-row">
          <h2>Canal Slack del equipo interno</h2>
          <span
            class="status-pill"
            [class.status-pill--ok]="has_configured_channel() && !has_bot_not_member()"
            [class.status-pill--pending]="!has_configured_channel() || has_bot_not_member()"
          >
            {{ status_pill_label() }}
          </span>
        </div>
        <p class="section-description">
          Elige el canal del workspace Bisual donde el equipo interno habla de este producto. Lo usan las búsquedas de chat y solo puede
          configurarlo el Account Manager.
        </p>
      </div>
    </header>

    @if (has_bot_not_member()) {
      <div class="bot-membership-warning" role="status">
        <mat-icon aria-hidden="true">warning</mat-icon>
        <p>
          El bot de Bisual no está añadido a este canal. Sin eso no se pueden enviar avisos de despliegues ni monitores. Invita al bot al
          canal en Slack.
        </p>
      </div>
    }

    <div class="channel-panel">
      <div class="channel-panel-label">Canal seleccionado</div>
      <div class="channel-panel-value-row">
        <div class="channel-panel-value" [class.channel-panel-value--empty]="!has_configured_channel()">
          @if (has_configured_channel()) {
            <mat-icon class="channel-hash-icon" aria-hidden="true">tag</mat-icon>
            <span class="channel-name">{{ configured_channel_display_name() }}</span>
          } @else {
            <mat-icon class="channel-empty-icon" aria-hidden="true">forum</mat-icon>
            <span>Todavía no hay canal configurado</span>
          }
        </div>

        <div class="channel-panel-actions">
          <button mat-flat-button color="primary" type="button" (click)="openChannelSelector()" [disabled]="loading_channels() || saving()">
            <mat-icon>{{ has_configured_channel() ? 'swap_horiz' : 'add' }}</mat-icon>
            {{ channel_selector_button_label() }}
          </button>
          @if (loading_channels() || saving()) {
            <mat-spinner diameter="22"></mat-spinner>
          }
        </div>
      </div>

      @if (configured_conversation_id(); as conversation_id) {
        <div class="channel-panel-meta">ID Slack: {{ conversation_id }}</div>
      }
    </div>
  </section>
</div>
